<template lang="pug">
div(v-loading.body="loading")
  el-row
    el-col(:sm="4")
      el-select(v-model="filters.company", clearable, placeholder="Фирма")
        el-option(v-for="c in companies", :label="c.name", :value="c.id", :key="c.id")
    el-col(:sm="7")
      el-date-picker(v-model="filters.range", type="daterange", align="left", placeholder="Избери период", :picker-options="rangeOptions", :clearable="false")
    el-col(:sm="4")
      el-select(v-model="filters.unit", placeholder="Избери единица")
        el-option(v-for="(unit, id) in unitOptions", :label="unit.label", :value="id", :key="id")
    el-col(:sm="6")
      el-select(v-model="mode", placeholder="Избери режим")
        el-option(label="Фактура / Кредитно / Без Документ", value="1")
        el-option(label="Фактура - Кредитно / Без Документ", value="13")
        el-option(label="Фактура - Кредитно + Без Документ", value="123")
    el-col(:sm="3")
      el-select(v-model="filters.status", clearable, placeholder="Статус")
        el-option(v-for="(status, id) in consts.paymentStatus", :label="status.title", :value="id", :key="id")

  el-row(style="margin-top: 10px")
    el-col(:sm="4")
      el-select(v-model="filters.subject", clearable, placeholder="Основание")
        el-option-group(label="Приход")
          el-option(v-for="(subject, id) in consts.subjectType[1]", :label="subject.title", :value="id", :key="id")
        el-option-group(label="Разход")
          el-option(v-for="(subject, id) in consts.subjectType[2]", :label="subject.title", :value="id", :key="id")
    el-col(:sm="3" v-if="filters.subject === '1010'")
      el-select(v-model="filters.subscriptionType", clearable, placeholder="Вид абонамент")
        el-option(v-for="(type, value) in consts.subscriptionType", :label="type.title", :value="value", :key="value")
    el-col(:sm="3" v-if="filters.subject === '1010'")
      el-select(v-model="filters.subscriptionVariant", clearable, placeholder="Вариант абонамент")
        el-option(v-for="(variant, value) in consts.subscriptionVariant", :label="variant.title", :value="value", :key="value")


  h1(style="text-align: center") {{ reportTitle }}
  report-chart(:raw-data="rawData", :tick-format="tickFormat", :data-info="dataInfo", :data-keys="modeKeys", style="margin-bottom: 50px")
  report-totals(:raw-data="rawData", :tick-format="tickFormat", :data-info="dataInfo", :data-keys="modeKeys", style="margin-bottom: 50px")
  report-table(:raw-data="rawData", :tick-format="tickFormat", :data-info="dataInfo", :data-keys="modeKeys", style="margin-bottom: 30px")
</template>

<script>
import * as dateUtil from '../lib/dateUtil'
import ReportChart from './ReportChart.vue'
import ReportTable from './ReportTable.vue'
import ReportTotals from './ReportTotals.vue'

import endOfYear from 'date-fns/end_of_year'
import startOfYear from 'date-fns/start_of_year'
import endOfMonth from 'date-fns/end_of_month'
import startOfMonth from 'date-fns/start_of_month'


const colors = {
  r: '#FF4949',
  lr: '#ff9e9e',
  dr: '#e20000',
  g: '#13CE66',
  lg: '#48ee92',
  dg: '#0c8040',
  b: '#555555',
}

const currentDate = new Date()
const lastMonth = new Date()
lastMonth.setDate(1)
lastMonth.setMonth(lastMonth.getMonth() - 1)
const currentYear = currentDate.getFullYear()

export default {
  name: 'Reports',
  data () {
    return {
      url: '/reports',
      apiUrl: '/reports',
      loading: true,
      filters: {
        range: [startOfMonth(currentDate), endOfMonth(currentDate)],
        unit: 'day',
        company: null,
        status: null,
        subject: null,
        subscriptionType: null,
        subscriptionVariant: null
      },
      mode: '1',
      rawData: {x: [], '1_1': [], '1_2': [], '1_3': [], '2_1': [], '2_2': [], '2_3': []},
      unitOptions: {
        day: {label: 'по Дни', format: 'D, MMM, YYYY'},
        month: {label: 'по Месеци', format: 'MMM, YYYY'},
        year: {label: 'по Години', format: 'YYYY'},
      },
      rangeOptions: {
        shortcuts: [{
            text: currentYear,
            onClick: picker => {
              this.filters.unit = 'month'
              picker.$emit('pick', [new Date(currentYear, 0, 1), new Date(currentYear, 11, 31)])
            }
          }, {
            text: currentYear - 1,
            onClick: picker => {
              this.filters.unit = 'month'
              picker.$emit('pick', [new Date(currentYear - 1, 0, 1), new Date(currentYear - 1, 11, 31)])
            }
          }, {
            text: dateUtil.format(currentDate, 'MMM, YYYY'),
            onClick: picker => {
              this.filters.unit = 'day'
              picker.$emit('pick', [startOfMonth(currentDate), endOfMonth(currentDate)]);
            }
          }, {
            text: dateUtil.format(lastMonth, 'MMM, YYYY'),
            onClick: picker => {
              this.filters.unit = 'day'
              picker.$emit('pick', [startOfMonth(lastMonth), endOfMonth(lastMonth)]);
            }
          }]
      },
      dataInfo: {
        '1_1': {color: colors.g, name: 'Приход фактури', labelPosition: 'insideTop'},
        '2_1': {color: colors.r, name: 'Разход фактури', labelPosition: 'insideTop'},

        '1_3': {color: colors.dg, name: 'Приход кредитно', labelPosition: 'bottom'},
        '2_3': {color: colors.dr, name: 'Разход кредитно', labelPosition: 'bottom'},

        '1_13': {color: colors.g, name: 'Приходи(ф-к)', labelPosition: 'insideTop'},
        '2_13': {color: colors.r, name: 'Разходи(ф-к)', labelPosition: 'insideTop'},
        '1_123': {color: colors.g, name: 'Приходи(ф-к+бд)', labelPosition: 'top'},
        '2_123': {color: colors.r, name: 'Разходи(ф-к+бд)', labelPosition: 'top'},

        '1_2': {color: colors.b, name: 'Приход без док', labelPosition: 'top'},
        '2_2': {color: colors.b, name: 'Разход без док', labelPosition: 'top'},

      }
    }
  },
  computed: {
    companies () {
      return this.$auth.check() ? this.$auth.user().tables.companies : []
    },
    minRange () {
      return dateUtil.format(this.filters.range[0], 'YYYY-MM-DD')
    },
    maxRange () {
      return dateUtil.format(this.filters.range[1], 'YYYY-MM-DD')
    },
    tickFormat () {
      return this.unitOptions[this.filters.unit].format
    },
    modeKeys () {
      if (this.mode === '1') {
        return ['1_1', '1_2', '1_3', '2_1', '2_2', '2_3']
      }
      if (this.mode === '13') {
        return ['1_13', '1_2', '2_13', '2_2']
      }
      if (this.mode === '123') {
        return ['1_123', '2_123']
      }
    },
    reportTitle () {
      return dateUtil.format(this.filters.range[0], 'D MMM, YYYY') + ' - ' + dateUtil.format(this.filters.range[1], 'D MMM, YYYY')
    }
  },
  methods: {
    loadData () {
      const params = {
        min: this.minRange,
        max: this.maxRange,
        unit: this.filters.unit,
        company: this.filters.company,
        status: this.filters.status,
        subject: this.filters.subject,
        subscriptionType: this.filters.subscriptionType,
        subscriptionVariant: this.filters.subscriptionVariant
      }
      this.loading = true
      this.$http.get(this.apiUrl, {params}).then((response) => {
        this.rawData = response.data
        this.loading = false
      }, (error) => {
        console.error(error)
        this.loading = false
      })
    }
  },
  created () {
    this.$watch('filters', (newFilters, oldFilters) => {
      this.loadData()
    }, {deep: true, immediate: true})
  },
  components: {
    'report-chart': ReportChart,
    'report-table': ReportTable,
    'report-totals': ReportTotals
  }
}
</script>

<style lang="stylus">
</style>